import { mapValues } from 'lodash';
import { QueryCreatorType, queryKeyCreator } from './query-key-creator.ts';

export const queryResources = Object.freeze({
  account: 'account',
  allInvoicesOverviews: 'all-invoices-overviews',
  anonymousCustomersReport: 'anonymous-customers-report',
  arHealthMetrics: 'ar-health-metrics',
  catalogProducts: 'catalog-products',
  commitmentReport: 'commitment-report',
  connectedIntegrations: 'connected-integrations',
  contractPage: 'contractPage',
  contractPdf: 'contract-pdf',
  contractProductsOverviews: 'contract-products-overviews',
  contracts: 'contracts',
  creditItems: 'credit-items',
  creditLedgerOverview: 'creditLedgerOverview',
  creditNotes: 'creditNotes',
  creditPools: 'credit-pools',
  creditTypes: 'credit-types',
  customer: 'customer',
  customerPortalDailyUsageData: 'customer-portal-daily-usage-data',
  customerPortalCreditPools: 'customer-portal-credit-pools',
  customerPortalData: 'customer-portal-data',
  customerPortalInvoicePdf: 'customer-portal-invoice-pdf',
  customerPortalMonthlyUsageData: 'customer-portal-monthly-usage-data',
  customersOverviews: 'customersOverviews',
  customersOverviewsNew: 'customers-overviews-new',
  customerMasterReport: 'customer-master-report',
  customersReport: 'customers-report',
  dynamicInvoice: 'dynamicInvoice',
  exportedInvoiceIntegration: 'exported-invoice-integration',
  exportedInvoiceIntegrations: 'exported-invoice-integrations',
  exchangeRates: 'exchange-rates',
  exchangeRatesMatrix: 'exchange-rates-matrix',
  externalLink: 'external-link',
  failedInvoiceDeliveriesReport: 'failed-invoice-deliveries-report',
  integration: 'integration',
  integrationSettings: 'integration-settings',
  invitations: 'invitations',
  invoice: 'invoice',
  invoicePdf: 'invoicePdf',
  invoiceProductsIntegrations: 'invoice-products-integrations',
  invoices: 'invoices',
  invoicesBreakdownStats: 'invoices-breakdown-stats',
  invoicesOverviewsNew: 'invoices-overviews-new',
  measurements: 'measurements',
  measurementsStats: 'measurementsStats',
  meterInstanceKeys: 'meter-instance-keys',
  meters: 'meters',
  monthlyClosureReport: 'monthly-closure-report',
  morningCustomers: 'morningCustomers',
  mrrWaterfall: 'mrr-waterfall',
  netSuiteClasses: 'netSuiteClasses',
  netSuiteCustomer: 'netSuiteCustomer',
  netSuiteCustomers: 'netSuiteCustomers',
  netSuiteInvoiceDashboardUrl: 'netSuiteInvoiceDashboardUrl',
  paddleTransactionUrl: 'paddleTransactionUrl',
  netSuiteSubsidiaries: 'netSuiteSubsidiaries',
  notifications: 'notifications',
  plans: 'plans',
  plansOverviews: 'plansOverviews',
  pricingTemplate: 'pricing-template',
  productPage: 'product-page',
  productsIntegrationEntities: 'products-integration-entities',
  productsPage: 'products-page',
  productsUsageReport: 'products-usage-report',
  productUsageChartData: 'product-usage-chart-data',
  productDescription: 'product-description',
  quickbooksCustomers: 'quickbooksCustomers',
  quickbooksProducts: 'quickbooksProducts',
  stripeCustomers: 'stripe-customers',
  recentlyUsedPlans: 'recentlyUsedPlans',
  reports: 'reports',
  slackChannels: 'slack-channels',
  slackUsers: 'slack-users',
  subsidiaries: 'subsidiaries',
  topOverdueCustomers: 'top-overdue-customers',
  unchargedUsageReport: 'uncharged-usage',
  usageByMeter: 'usage-by-meter',
  usageEventsReportConfiguration: 'usage-events-report-configuration',
  users: 'users',
  sandboxUser: 'sandbox-user',
  phaseLabels: 'phase-labels',
  jobs: 'jobs',
  jobTasks: 'job-tasks',
  labels: 'labels',
  ytdBilledRevenue: 'ytd-billed-revenue',
  revenueByCurrency: 'revenue-by-currency',
  recurringRevenue: 'recurring-revenue',
  productUsageByDateBreakdown: 'product-usage-by-date-breakdown',
  dailyEventsDigested: 'daily-events-digested',
  customerContractsOverviewPage: 'customer-contracts-overview-page',
  customerCommitmentUsage: 'customer-commitment-usage',
  contractBillingSchedule: 'contract-billing-schedule',
  contractUsageBreakdown: 'contract-usage-breakdown',
  contractCreditPools: 'contract-credit-pools',
  approvalFlowInvoicesList: 'approval-flow-invoices-list',
  eventNames: 'event-names',
  eventFields: 'event-fields',
  eventFieldValues: 'event-field-values',
  customerPortalToken: 'customer-portal-token',
  customerInvoicePageData: 'customer-invoice-page-data',
  contractsReport: 'contracts-report',
  contractVersion: 'contract-version',
  contractSalesforceCustomFields: 'contract-salesforce-custom-fields',
  contractCustomFields: 'contract-custom-fields',
  contractBillingScheduleReport: 'contract-billing-schedule-report',
  contractRevenueScheduleReport: 'contract-revenue-schedule-report',
  billingCyclesOverview: 'billing-cycles-overview',
  arAgingReport: 'ar-aging-report',
  homePageAccountSummary: 'home-page-account-summary',
  netSuiteProducts: 'net-suite-products',
  invoicesSummaryReport: 'invoices-summary-report',
  paymentsOverview: 'payments-overview',
  paymentsNew: 'payments-new',
  paymentsNewAll: 'payments-new-all',
  paymentMethods: 'payment-methods',
  depositTo: 'deposit-to',
  invoiceSummary: 'invoice-summary',
  billingCyclePage: 'billing-cycle-page',
  pdf: 'pdf',
  invoiceStatistics: 'invoice-statistics',
  invoicesHighlightsStatistics: 'invoices-highlights-statistics',
  affectedMeteredEvents: 'affected-metered-events',
  contractsOverview: 'contracts-overview',
  customersNames: 'customers-names',
  events: 'events',
  billingCycleInvoices: 'billing-cycle-invoices',
  recurringRevenueReport: 'recurring-revenue-report',
  customerRevenueReport: 'customer-revenue-report',
  journalEntriesReport: 'journal-entries-report',
  commitmentVsUsageReport: 'commitment-vs-usage-report',
  unmeteredEventsReport: 'unmetered-events-report',
  usageReportV2Report: 'usage-report-v2-report',
  upcomingInvoicesReport: 'upcoming-invoices-report',
  customersCountByStatus: 'customers-count-by-status',
  totalTax: 'total-tax',
  taxableRevenue: 'taxable-revenue',
  paddleCustomers: 'paddle-customers',
  paddleProducts: 'paddle-products',
  xeroCustomers: 'xero-customers',
  xeroProducts: 'xero-products',
  customerNotes: 'customer-notes',
  customFieldDefinitions: 'custom-field-definitions',
});

export type QueryKeys = typeof queryResources;

export const queryKeys: Record<keyof typeof queryResources, QueryCreatorType> = mapValues(
  queryResources,
  queryKeyCreator,
);
